export default __webpack_public_path__ + "static/media/IF_MySalesStyle_StrengthArea_03.b9c69f33.jpg";